import { render, staticRenderFns } from "./InspectionCriteria.vue?vue&type=template&id=20a9e1cc&scoped=true"
import script from "./InspectionCriteria.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria.vue?vue&type=style&index=0&id=20a9e1cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a9e1cc",
  null
  
)

export default component.exports